import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  ${({ theme }) => css`
    font-family: ${theme.v2.font.family.primary};
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-direction: column;
    box-sizing: border-box;
    width: 100%;
    gap: 16px;
  `}
`;

export const Greeting = styled.div`
  ${({ theme }) => css`
    color: ${theme.v2.colors.brand.primaryExtraDark};
    font-size: ${theme.v2.font.sizes.sm2};
    font-weight: ${theme.v2.font.weights.bold};
    width: 100%;
    text-align: center;
    margin-top: 24px;

    @media (min-width: ${theme.v2.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.sm};
    }
  `}
`;

export const WordpressAIWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    background: linear-gradient(to top, #E7F3FD 40%, #FFFFFF  100%);
    overflow: hidden;
`;

export const WordpressAIContainer = styled.div`
  ${({ theme }) => css`
    max-width: 1000px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    @media (min-width: ${theme.v2.breakpoints.lg}) {
      justify-content: space-between;
      max-width: 1440px;
    }
  `}
`;

export const WordpressAIAbout = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    max-width: 100%;
    height: 100%;
    padding: 16px;

    @media (min-width: ${theme.v2.breakpoints.md}) {
      padding: 24px;
    }
  `}
`;

export const WordpressAIAboutContent = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    gap: 24px;

    @media (min-width: ${theme.v2.breakpoints.md}) {
      align-items: flex-start;
      width: auto;
      min-width: 475px;
    }
  `}
`;

export const WordpressAIAboutHeader = styled.div`
    box-sizing: border-box;
    border-radius: 16px 16px 0 0;
    display: flex;
    align-items: flex-start;
    flex-direction: column;
`;

export const WordpressAITitle = styled.div`
  ${({ theme }) => css`
    color: ${theme.v2.colors.brand.primaryExtraDark};
    font-size: ${theme.v2.font.sizes.md};
    font-weight: ${theme.v2.font.weights.medium};
    line-height: ${theme.v2.font.lineHeight.text};
  `}
`;

export const WordpressAIDescription = styled.div`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.regular};
    line-height: ${theme.v2.font.lineHeight.text};
    display: flex;
    align-items: center;
    justify-content: flex-start;

    p {
      margin: 0;
    }
  `}
`;

export const BulletPointsList = styled.div`
  ${({ theme }) => css`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 16px;
    font-size: ${theme.v2.font.sizes.regular};
    color: ${theme.v2.colors.neutral.lowDark};
    align-items: center;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      grid-template-columns: 1fr;
    }
  `}
`;

export const BulletPointsItem = styled.div`
  display: flex;
  gap: 8px;
`;

export const WordpressAITag = styled.div`
  ${({ theme }) => css`
    background: ${theme.v2.colors.feedback.activeUltraLight};
    color: ${theme.v2.colors.feedback.activeDark};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.medium};
    line-height: ${theme.v2.font.lineHeight.text};
    padding: 6px 16px;
    border-radius: 100px;
    width: fit-content;
    margin-bottom: 16px;
  `}
`;

export const WordpressAIButton = styled.div`
  button{
    ${({ theme }) => css`
      @media (min-width: ${theme.v2.breakpoints.md}) {
        font-size: ${theme.v2.font.sizes.sm2};
      }
    `}
  }
`;

export const WordpressAIImage = styled.img`
  ${({ theme }) => css`
    display: none;

    @media (min-width: ${theme.v2.breakpoints.md}) {
      display: block;
      height: 353px;
      align-self: flex-end;
      margin-right: 40px;
    }
  `}
`;

export const OthersOptionsWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    max-width: 1000px;
    width: 100%;
    align-items: center;
    flex-direction: column;
    flex-wrap: wrap;
    gap: 16px;
    box-sizing: border-box;

    @media (min-width: ${theme.v2.breakpoints.lg}) {
      gap: 24px;
      flex-direction: row;
      max-width: 1440px;
      justify-content: space-between;
    }
  `}
`;

export const BackWrapper = styled.div`
  align-items: flex-start;
  display: flex;
  margin: 24px auto 0px;
  max-width: 1440px;
  width: 100%;
`;
